import { DATE_FORMAT } from "constants/dateFormat";
import { isEn } from "i18next-config";
import moment from "moment";

// const populateWeek = (startDate, endDate) => {
//   let currentDate = moment(startDate);
//   const finalDate = moment(endDate);
//   const week = {};
//   while (currentDate <= finalDate) {
//     const formattedDate = currentDate.format(DATE_FORMAT);
//     week[formattedDate] = {
//       exists: false,
//       cloudCover: null,
//     };
//     currentDate = currentDate.add(1, "days");
//   }
//   return week;
// };

export class IndicesDto {
  static fromApiArray(data) {
    const availableDates = [];
    const indices = {};

    data.forEach((index) => {
      const date = moment(index.date).format(DATE_FORMAT);
      availableDates.push(date);

      let lowerCloudCoveredIndex = index;
      if (date in indices) {
        lowerCloudCoveredIndex = Math.min(
          index.cloudCover,
          indices[date].cloudCover
        );
      }
      indices[date] = lowerCloudCoveredIndex;
    });
    return { availableDates, indices };
  }

  static fromApiArrayDates(data) {
    // let weeklyIndices = populateWeek(dates.startDate, dates.endDate);

    // data.forEach((item) => {
    //   const date = moment(item.date).format(DATE_FORMAT);
    //   weeklyIndices[date] = {
    //     exists: true,
    //     cloudCover: item.cloudCover,
    //   };
    // });
    // return weeklyIndices;

    return data.map((item) => moment(item.date).format(DATE_FORMAT));

    // return data.map((item) => ({
    //   dates: availableDates,
    //   data: {
    //     date: moment(item.date).format(DATE_FORMAT),
    //     cloudCover: item.cloudCover,
    //   },
    // }));
  }

  static fromApiArrayToOne(data) {
    if (Array.isArray(data)) {
      return data[0];
    }
    return;
  }

  static fromApiArrayTypes(data) {
    return data
      .filter((item) => item.use)
      .map((item) => ({
        description: isEn ? item.descriptionEn : item.descriptionGr,
        value: item.index,
        label: item.name?.toUpperCase(),
        range: { min: item.range[0], max: item.range[1] },
        gradient: `linear-gradient(to right, ${item.colormapHex?.join(", ")})`,
      }));
  }
}
